// extracted by mini-css-extract-plugin
export default {"customPadding":"Products_customPadding__DZJea","nameContainer":"Products_nameContainer__-4tWl"};